import {Autocomplete, Grid2 as Grid, TextField} from "@mui/material";
import React from "react";
import {createFilterOptions} from "@mui/material/Autocomplete";

export interface FormAutoCompleteItem {
  label: string;
  value: string;
  group?: {id: string, label: string};
}

interface FormAutoCompleteProps {
  name: string;
  label: string;
  items: FormAutoCompleteItem[];
  values: Record<string, any>;
  onChange: (name: string, value: FormAutoCompleteItem | null) => void;
  size?: number | "grow" | "auto";
  required?: boolean;
}

export default function FormAutoComplete({name, label, items, values, size = 12, onChange, required=false}: FormAutoCompleteProps) {
  // The organization selection has over 15k options for counter admins
  // To not kill the performance, we limit the options shown to 100

  return <Grid size={size}>
    <Autocomplete
      fullWidth
      data-testid={name}
      options={items}
      autoHighlight={true}
      value={values[name]}
      filterOptions={createFilterOptions({limit: 100})}
      groupBy={(option: FormAutoCompleteItem) => option.group?.label ?? ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(e, v) => onChange(name, v)}
      renderInput={(params) => <TextField {...params} required={required} label={label} />} />
  </Grid>;
}
